import { render, staticRenderFns } from "./profilePage.vue?vue&type=template&id=6215f656&"
import script from "./profilePage.vue?vue&type=script&lang=js&"
export * from "./profilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports